var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTradeOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.125 1.25V12.4062C2.125 12.7051 2.35742 12.9375 2.65625 12.9375H15.9375C16.502 12.9375 17 13.4355 17 14C17 14.5977 16.502 15.0625 15.9375 15.0625H2.65625C1.16211 15.0625 0 13.9004 0 12.4062V1.25C0 0.685547 0.464844 0.1875 1.0625 0.1875C1.62695 0.1875 2.125 0.685547 2.125 1.25ZM15.6055 4.13867L11.3555 8.38867C10.957 8.82031 10.2598 8.82031 9.86133 8.38867L7.96875 6.49609L4.98047 9.45117C4.58203 9.88281 3.88477 9.88281 3.48633 9.45117C3.05469 9.05273 3.05469 8.35547 3.48633 7.95703L7.20508 4.23828C7.60352 3.80664 8.30078 3.80664 8.69922 4.23828L10.625 6.13086L14.1113 2.64453C14.5098 2.21289 15.207 2.21289 15.6055 2.64453C16.0371 3.04297 16.0371 3.74023 15.6055 4.13867Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeOrder);
export default __webpack_public_path__ + "static/media/TradeOrder.43b35f7e6ac75e0808e54101ef5a509a.svg";
export { ForwardRef as ReactComponent };